import * as moment from 'moment';
export const bestUsersOptions = (translate, data, limit) => ({
  title: {
    // text: translate.instant('stats.time_users'),
    // subtext: `best ${limit} users`,
  },
  series: [
    {
      type: 'pie',
      data: data.map(item => item),
      radius: '50%',
      center: ['50%', '50%']
    }
  ]
});
export const getVisitsOptions = (translate, data, limit) => ({
  title: {
    // text: translate.instant('stats.visits_users'),
    // subtext: `best ${limit} users`,
  },
  series: [
    {
      type: 'pie',
      data: data.map(item => item),
      radius: '50%',
      center: ['50%', '50%']
    }
  ]
});
export const getConcurrentUsersOptions = data => ({
  xAxis: { data: data.map(item => moment(item.name).format('LLL')) },
  series: [{ type: 'line', sampling: 'average', data: data.map(item => item.value) }]
});
export const getViewsFilteredOptions = (translate, data, filter) => ({
  title: {
    // text: translate.instant('stats.views_session'),
    subtext: `filtered by : ${filter}`
  },
  series: [{ type: 'line', sampling: 'average', data: data.map(item => item.value) }]
});
export const getViewsFilteredOptionCumulativeOption = (translate, data, filter) => {
  let counter = 0;
  return {
    title: {
      // text: translate.instant('stats.views_session_2'),
      subtext: `filtered by : ${filter}`
    },
    series: [
      {
        type: 'line',
        sampling: 'average',
        data: data.map(item => {
          counter += item.value;
          return counter;
        })
      }
    ]
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/stats/dashboard/chartOptions.ts